import { constantTree } from "../../../core/events/ConstantTree";

export const fmlmViewInfoTree = constantTree({
  Filter: {
    GetFmlmOffers: "",
    UpdateFilter: "",
  },
  Booking: {
    BookNow: "",
  },
})
